<template>
  <el-dialog custom-class="max-dialog" :title="this.title" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-col :span="24">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(210)"
          size="mini"
          border
          stripe
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>

          <el-table-column
            prop="uname"
            label="操作人"
            align="left"
            header-align="center">
          </el-table-column>

          <el-table-column
            prop="dname"
            label="操作人部门"
            align="left"
            header-align="center">
          </el-table-column>

          <el-table-column
            align="center"
            label="使用时间">
            <template slot-scope="scope">
              {{(scope.row.adddate || "").substr(0, 10)}}
            </template>
          </el-table-column>

          <el-table-column
            prop="money"
            label="使用金额"
            align="left"
            header-align="center">
            <template slot-scope="scope">
              {{scope.row.money | numeric(2)}}
            </template>
          </el-table-column>

        </el-table>
        <div class="foot" :style="{textAlign:'center' }">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
    </el-col>
  </el-dialog>
</template>


<script>
  import {getListData} from '@/api/set/machinecouponhis'

  export default {
    name: "DataContactEdit",
    data() {
      return {
        dialogFormVisible: false,
        formLabelWidth: '120px',
        title: '',
        form: {},
        tableData: [],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        }
      }
    },
    methods: {
      show(title) {
        this.title = title;
        this.dialogFormVisible = true;
      },
      bindGrid(unitguid, couponguid) {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          // dserial: unitguid,
          couponguid: couponguid
        }).then(response => {
          this.tableData = response.data.rows
          this.pagination.total = response.data.total
        }).catch((error) => {
          console.log(error)
        });
      }
    },
    mounted() {
    },
    components: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/set/salefavour/Userecordt.vue